module.exports = __webpack_public_path__ + "static/media/UNMClogo.eda8ec63.png";